module.exports = __webpack_public_path__ + "fae5c7ef086ba74904b7b1b02dd09ecd.MP3";